import React from 'react';
import PropTypes from 'prop-types';
import {
  compose,
  displayNumber,
  newFormatPrice,
} from '../../services/utilityFunctions';
import translate from '../../commonComponents/translate';
import withCSRF from '../../commonComponents/withCSRF';

function ShopAvailableCoupon({
  t,
  coupon,
  onClick,
  selectedCoupon,
  orderAlreadyCreated,
  couponContainerClass,
  selectedCoins,
  handleCoinsClick,
}) {
  // Render de value to show
  const renderCouponValue = () => {
    let couponValue;
    if (coupon.userPrice?.total) {
      const currencyToUse = coupon.userPrice
        ? coupon.userPrice.code
        : coupon.currency;
      couponValue = `${newFormatPrice(
        coupon.userPrice?.total,
        true,
        currencyToUse,
      )}`;
    } else {
      couponValue = `${coupon.percentOff}%`;
    }
    return <span className="coupon-discount py-0 my-0">{couponValue}</span>;
  };
  const isCoins = coupon.code.toLowerCase() === 'coins';
  const image = isCoins ? '/images/shop/coins.svg' : '/images/shop/coupon.svg';
  const imageContainerClass = `col-3 text-center coupon-preview-container p-2 ${
    isCoins ? 'isCoins' : ''
  } ${
    selectedCoupon === coupon.code || selectedCoins === coupon.code
      ? ''
      : 'active'
  }`;
  let coinsAmount = 0;
  let valueAmount = 0;
  let currency = 'eur';
  if (isCoins) {
    coinsAmount =
      coupon?.metadata && coupon?.metadata.coins >= 0
        ? coupon?.metadata.coins
        : 0;
    valueAmount =
      coupon?.amountOffAvailable && coupon?.amountOffAvailable >= 0
        ? coupon.amountOffAvailable
        : 0;
    currency = coupon?.currency ? coupon.currency : 'eur';
  }
  return (
    <button
      type="button"
      className={`${couponContainerClass} remove-padding-col remove-style-btn ${
        orderAlreadyCreated ? 'disabled-btn' : ''
      }`}
      disabled={orderAlreadyCreated}
      onClick={() => (isCoins ? handleCoinsClick(coupon) : onClick(coupon))}
      title={
        !isCoins
          ? coupon?.name || ''
          : t('shop.checkout.coupon.isPaidWithCoins')
      }
    >
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
      <div
        className={`row mx-1 discount-coupon-card mb-2 px-2 vertical-center ${
          selectedCoupon === coupon.code || selectedCoins === coupon.code
            ? 'active'
            : ''
        }`}
      >
        <div className={imageContainerClass}>
          <img
            src={image}
            alt="Coupon preview"
            className={`coupon-preview-img ${isCoins ? 'isCoins-image' : ''}`}
          />
        </div>
        {!isCoins ? (
          <div className="col-lg-10 col-8 container-coupon-name">
            <div className="wrapper-coupon-name">
              <div className="coupon-name">{coupon.name}</div>
              {renderCouponValue()}
            </div>
          </div>
        ) : (
          <div className="col-lg-9 col-8 remove-padding-coupon coupon-isCoins-container">
            <div className="row mx-0 px-0">
              <div className="col-12 mb-0 pb-0 name">
                <span className="coupon-name">
                  {t('shop.checkout.coupon.isPaidWithCoins')}
                </span>
              </div>
              <div
                className={`col-12 mt-0 pt-0 values-container ${
                  selectedCoupon === coupon.code ||
                  selectedCoins === coupon.code
                    ? 'coinsActive'
                    : ''
                }`}
              >
                <div className="row values">
                  <p className="values-coins">
                    {`${displayNumber(coinsAmount)} ${t(
                      'shop.checkout.coupon.coins',
                    )}`}
                  </p>
                  <p className="values-monetary">
                    {newFormatPrice(valueAmount, true, currency)}
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </button>
  );
}

ShopAvailableCoupon.propTypes = {
  t: PropTypes.func.isRequired,
  selectedCoupon: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  handleCoinsClick: PropTypes.func.isRequired,
  selectedCoins: PropTypes.string.isRequired,
  coupon: PropTypes.shape({
    name: PropTypes.string.isRequired,
    code: PropTypes.string.isRequired,
    amountOffAvailable: PropTypes.number,
    percentOff: PropTypes.number,
    currency: PropTypes.number,
    userPrice: PropTypes.shape({
      price: PropTypes.number.isRequired,
      total: PropTypes.number.isRequired,
      code: PropTypes.string.isRequired,
    }).isRequired,
    metadata: PropTypes.shape({
      coins: PropTypes.number,
    }),
  }),
  orderAlreadyCreated: PropTypes.string,
  couponContainerClass: PropTypes.string,
};

ShopAvailableCoupon.defaultProps = {
  coupon: PropTypes.shape({
    name: '',
    code: '',
    amountOffAvailable: 0,
    percentOff: 0,
    userPrice: {},
  }),
  orderAlreadyCreated: '',
  couponContainerClass: 'col-12 col-lg-4 my-1 my-lg-0',
};

export default compose(translate, withCSRF)(ShopAvailableCoupon);
